export const TABLE_TOTAL_SUMMARY_TYPE = 'totalSummary';
export const TABLE_GROUP_SUMMARY_TYPE = 'groupSummary';
export const TABLE_TREE_SUMMARY_TYPE = 'treeSummary';
